export const changeTheme = (themeColors) => {
  for (const variable in themeColors) {
    document
      .querySelector(":root")
      .style.setProperty(variable, themeColors[variable]);
  }
};
